export default __webpack_public_path__ + "static/media/foundU-logo.246d25f7.svg";